<!-- page title area end -->
<div class="main-content-inner mt-2">
  <h1 class="text-center">Import des données Soft-Drop</h1>

  <div class="w-100 d-flex justify-content-center">
    <div class="sd-upload-container mt-5 dropzone" id="dropzone"
         (click)="input.click()"
         (dragover)="dragOver($event)"
         (dragleave)="dragLeave($event)"
         (drop)="dropHandler($event)"
    >
      <input #input type="file" class="d-none" (change)="chargeFile(input.files[0]);" id="fileInput" name="file">
      <p><strong>Déposez un fichier ici</strong></p>
      <p>ou cliquez pour sélectionner</p>
      <div class="mb-3 cursor-pointer"><img src="assets/icons/cloud-backup-icon.svg" height="50" alt="importer"></div>
      <small>{{!fileName ? 'Aucun fichier sélectionné' : fileName}}</small>
    </div>
  </div>
  <div class="w-100 text-center"><small class="text-danger" *ngIf="wrongFormat">Le fichier doit être au format .csv</small></div>
  <div class="mt-3 w-100 d-flex justify-content-center">
    <button class="btn btn-dark" [disabled]="wrongFormat || !file" (click)="sendFile()">Envoyer</button>
  </div>
</div>
